import { createTheme } from '@mui/material';
const theme = (context) => {
  let mainColor = '#54DE7E';
  let textColor = '#fff';
  if (context && context.mainColor) {
    mainColor = context.mainColor;
  }
  if (context && context.textColor) {
    textColor = context.textColor;
  }
  return createTheme({
    palette: {
      primary: {
        main: mainColor,
      },
      secondary: {
        main: '#4ECB71',
      },
      grey: {
        main: '#bfbfbf',
      },
      cancel: {
        main: '#6C6C6C',
      },
      eMedButton: {
        main: '#D93534',
      },
      error: {
        main: '#ED1C24',
      },
      info: {
        main: '#4F9AF6',
      },
      success: {
        main: '#11B33F',
      },
    },
    components: {
      MuiGrid: {
        styleOverrides: {
          root: {
            paddingLeft: '10px',
          },
          container: {
            paddingRight: '10px',
          },
        },
      },
    },
    typography: {
      body: {
        fontSize: '1.05rem',
      },
      title: {
        fontSize: '1.25rem',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        textAlign: 'center',
        color: textColor,
      },
      note: {
        fontSize: '1.05rem',
        fontWeight: 'bold',
        color: '#979797',
        textAlign: 'center',
      },
      subNote: {
        fontSize: '0.9rem',
        fontWeight: 'bold',
        color: '#979797',
        textAlign: 'center',
      },
      subHighlight: {
        fontSize: '0.9rem',
        fontWeight: 'bold',
        color: 'blue',
        textAlign: 'center',
      },
      titleMainColor: {
        fontSize: '1.1rem',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        textAlign: 'center',
        color: mainColor,
      },
      subTitleMainColor: {
        fontSize: '1rem',
        fontWeight: 'bold',
        textAlign: 'center',
        color: mainColor,
      },
      description: {
        fontSize: '1rem',
        lineHeight: '1.3rem !important',
      },
    },
  });
};
export default theme;
